import {StyleSheet} from "react-native";
import {ChatRecord, useChat} from "@/lib/providers/ChatProvider";
import Page from "@/lib/pages/Page";
import {useMemo, useState} from "react";
import Table from "@/lib/components/Table";
import {Color, rowColor} from "@/lib/styles";
import ChatRow from "@/lib/components/ChatRow";
import SpinnerPage from "@/lib/pages/SpinnerPage";
import Center from "@/lib/components/Center";
import NavButton from "@/lib/components/NavButton";
import {useSession} from "@/lib/auth/auth";

export default function Index() {
    const {chats, chatConnected, chatError} = useChat();
    const {session, isLoading} = useSession();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [showHidden, setShowHidden] = useState(false);

    const sortedChats = useMemo(() => {
        const sorted: ChatRecord[] = [];
        if (!chats) {
            return [];
        }
        chats.forEach(value => {
            if (value.chat.hidden && !showHidden) {
                return;
            }
            sorted.push(value);
        });
        sorted.sort((a, b) => {
            if (!a.chat.lastActivity || !b.chat.lastActivity) {
                return 0;
            }
            return (b.chat.lastActivity.unixMsec as number) - (a.chat.lastActivity.unixMsec as number);
        });
        return sorted;
    }, [chats, showHidden]);

    if (!isLoading && !session) {
        return (
            <Page>
                <Center style={{alignItems: "center"}}>
                    <NavButton href={`/u/account/login`} title={"Logg inn for å chatte"}/>
                </Center>
            </Page>
        );
    } else if (isLoading || !chatConnected) {
        return <SpinnerPage title={"Laster chat..."}/>
    } else if (!!chatError) {
        return <SpinnerPage title={`Venter på tilkobling...\n\n${chatError.message}`}/>
    }

    return (
        <Page scrollable={true}>
            {/*<PrimaryText>Uleste meldinger: {unreadChatMessages}</PrimaryText>*/}
            {/*<PrimaryText>Antall chats: {chats.size}</PrimaryText>*/}
            <Table>
                {sortedChats.map((record, index) => {
                    return (
                        <ChatRow key={record.chat.id}
                            // avatar={record.chat}
                            // badge={badge(participant)}
                            // badgeColor={color}
                                 id={record.chat.id}
                                 chat={record.chat}
                                 messages={record.messages}
                                 color={rowColor(Color.Container, index)}
                                 contrastColor={Color.PrimaryText}
                            // contrastColor={contrastColor}
                            // onPress={onPress}
                            // onEdit={onEdit ? onEdit(participant.avatar.username) : undefined}
                        />
                    )
                })}
            </Table>
        </Page>
    )
}

export const styles = StyleSheet.create({})